import React from "react";
import styles from "../blogCard/blogCard.module.scss";
import blogCardImg from "../../assests/blogCardImg.png";
import blogCardProfile from "../../assests/blogCardProfile.png";

const data = [
  {
    id: 1,
    img: blogCardImg,
    title: "Top Tips for effective budget Financial planning for you.",
    description:
      "Small businesses improving real-time finance efficiency, reducing, providing real-time.",
    profileImg: blogCardProfile,
    name: "Jenny Wilson",
    date: "Jan 10, 2024",
  },
  {
    id: 2,
    img: blogCardImg,
    title: "Top Tips for effective budget Financial planning for you.",
    description:
      "Small businesses improving real-time finance efficiency, reducing, providing real-time.",
    profileImg: blogCardProfile,
    name: "Jenny Wilson",
    date: "Jan 10, 2024",
  },
  {
    id: 3,
    img: blogCardImg,
    title: "Top Tips for effective budget Financial planning for you.",
    description:
      "Small businesses improving real-time finance efficiency, reducing, providing real-time.",
    profileImg: blogCardProfile,
    name: "Jenny Wilson",
    date: "Jan 10, 2024",
  },
  {
    id: 4,
    img: blogCardImg,
    title: "Top Tips for effective budget Financial planning for you.",
    description:
      "Small businesses improving real-time finance efficiency, reducing, providing real-time.",
    profileImg: blogCardProfile,
    name: "Jenny Wilson",
    date: "Jan 10, 2024",
  },
  {
    id: 5,
    img: blogCardImg,
    title: "Top Tips for effective budget Financial planning for you.",
    description:
      "Small businesses improving real-time finance efficiency, reducing, providing real-time.",
    profileImg: blogCardProfile,
    name: "Jenny Wilson",
    date: "Jan 10, 2024",
  },
  {
    id: 6,
    img: blogCardImg,
    title: "Top Tips for effective budget Financial planning for you.",
    description:
      "Small businesses improving real-time finance efficiency, reducing, providing real-time.",
    profileImg: blogCardProfile,
    name: "Jenny Wilson",
    date: "Jan 10, 2024",
  },
];
const BlogCard = () => {
  return (
    <div className={styles.container}>
      {data?.map((item) => (
        <div className={styles.card}>
          <div className={styles.top}>
            <img src={item?.img} alt="" className={styles.blogCardImg} />
          </div>
          <div className={styles.bottom}>
            <div className={styles.bottomTop}>
              <div className={styles.head}>{item?.title}</div>
              <div className={styles.description}>{item?.description}</div>
            </div>
            <div className={styles.bottomBottom}>
              <div className={styles.bottomLeft}>
                <img
                  src={item?.profileImg}
                  alt=""
                  className={styles.bottomLeftImage}
                />
                <div className={styles.name}>{item?.name}</div>
              </div>
              <div className={styles.bottomRight}>{item?.date}</div>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default BlogCard;
